module.exports = __webpack_public_path__ + "static/media/1701.17ccc6b7.mp3";